export default "__VITE_ASSET__Dh4a6Fvt__"